import React, { useEffect, useState } from 'react';
import { Grid, Card, CardContent, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import axios from 'axios';
import { API_URL } from '../../config';
import api from '../../api';
import PageHeader from '../../components/headers/Header';

// Styled components with your color palette
const StyledCard = styled(Card)(({ theme }) => ({
  backgroundColor: '#f0f5ff', // primaryLight
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
  borderRadius: '12px',
}));

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  marginTop: theme.spacing(2),
  '& th': { color: '#1565c0' }, // primary800
  '& td': { color: '#3d52a0' }, // secondaryMain
}));

const PayrollImpactDashboard = () => {
  const [payrollData, setPayrollData] = useState([]);

  useEffect(() => {
    api
      .get(`${API_URL}/payroll/impact/current-month`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      })
      .then((response) => {
        // Validate the response data
        if (Array.isArray(response.data)) {
          setPayrollData(response.data);
          console.log('Payroll data fetched successfully:', response.data);
        } else {
          console.error('Unexpected API response format:', response.data);
          setPayrollData([]); // Fallback to empty array
        }
      })
      .catch((error) => {
        console.error('Error fetching payroll data:', error);
        setPayrollData([]); // Fallback to empty array on error
      });
  }, []);

  return (
    <Grid container spacing={3} >
      <Grid item xs={12} style={{ width: '100%' }}>
        <PageHeader title="Current Month Payroll Impact" />
        <StyledCard>
          <CardContent>
            <StyledTableContainer component={Paper} >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Employee</TableCell>
                    <TableCell>Leave Days</TableCell>
                    <TableCell>Salary Deduction</TableCell>
                    <TableCell>Leave Bonus</TableCell>
                    <TableCell>Net Salary</TableCell>
                    <TableCell>Initial Salary</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {payrollData.filter(row => row !== null && row !== undefined).length > 0 ? (
                    payrollData
                      .filter(row => row !== null && row !== undefined)
                      .map((row) => (
                        <TableRow key={row.payrollId}>
                          <TableCell>
                            {row.employee
                              ? `${row.employee.firstName} ${row.employee.lastName}`
                              : 'N/A'}
                          </TableCell>
                          <TableCell>{row.leaveDays ?? 'N/A'}</TableCell>
                          <TableCell>{row.deduction ?? 0} dh</TableCell>
                          <TableCell>{row.bonus ?? 0} dh</TableCell>
                          <TableCell>{row.netSalary ?? 0} dh</TableCell>
                          <TableCell>{row.baseSalary ?? 0} dh</TableCell>
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        No data available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </StyledTableContainer>
          </CardContent>
        </StyledCard>
      </Grid>
    </Grid>
  );
};

export default PayrollImpactDashboard;